import React, { useMemo } from "react";

import { Car } from "../../../../../../services";
import { CellContentRoot } from "../../../../../LightTable";

const NoteCellContent: React.FC<NoteCellContent.Props> = ({ item }) => {
	const content = useMemo(() => item.notes ?? "", [item.notes]);

	return (
		<CellContentRoot alignItems="center" w="100%" h="100%">
			{content}
		</CellContentRoot>
	);
};

declare namespace NoteCellContent {
	interface Props {
		item: Car.Model;
	}
}

export default NoteCellContent;
